import AGREGAR_CONTRATISTA from '@/graphql/mutations/administracion/catalogos/contratistas/agregarContratista.gql';
import CONTRATISTAS from '@/graphql/querys/administracion/catalogos/contratistas/contratistas.gql';
import ACTUALIZAR_CONTRATISTA from '@/graphql/mutations/administracion/catalogos/contratistas/actualizarContratista.gql';
import REMOVER_CONTRATISTA from '@/graphql/mutations/administracion/catalogos/contratistas/removerContratista.gql';

export default {
  methods: {
    async mixAgregarContratista() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_CONTRATISTA,
        variables: this.contratista,
        update: (store, { data: { agregarContratista } }) => {
          const data = store.readQuery({ query: CONTRATISTAS });
          data.contratistas.push(agregarContratista);
          store.writeQuery({ query: CONTRATISTAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarContratista() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_CONTRATISTA,
        variables: this.contratista,
        update: (store, { data: { actualizarContratista } }) => {
          const data = store.readQuery({ query: CONTRATISTAS });
          const { contratistas } = data;
          const index = contratistas
            .findIndex((contratista) => contratista.id === actualizarContratista.id);
          if (index !== -1) {
            contratistas.splice(index, 1, actualizarContratista);
          }
          store.writeQuery({ query: CONTRATISTAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarContratista() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATISTA,
        variables: {
          id: this.contratistaEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: CONTRATISTAS });
          const { contratistas } = data;
          const index = contratistas
            .findIndex((contratista) => contratista.id === this.contratistaEliminar.id);
          if (index !== -1) {
            contratistas.splice(index, 1);
          }
          store.writeQuery({ query: CONTRATISTAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
